import Layout from "../../layout";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
import Loader from "../../components/Reusable/Loader";
import { useEffect } from "react";
import { useRouter } from "next/router";

const PAGE_CONFIG_URL = "/api/terms-and-conditions/config/";
const TermsAndConditions = ({ initialData, cookie="en" }) => {
  const router = useRouter();
  const { data: termsAndConditionsData, error: termsAndConditionsError } =
    useSWR(`/api/terms-and-conditions?language=${cookie}`, fetcher, {
      fallbackData: initialData,
    });

    useEffect(() => {
      router.replace(router.asPath);
    }, []);

  return (
    <div>
      {!termsAndConditionsData ? (
        <Loader />
      ) : termsAndConditionsError ? (
        <div className="terms_policy">
          <h1>Something went wrong</h1>
        </div>
      ) : (
        <>
          <div className="terms_policy">
            <h1>{termsAndConditionsData.terms_and_conditions.name}</h1>
            <hr />
            <div
              dangerouslySetInnerHTML={{
                __html: termsAndConditionsData?.terms_and_conditions?.value,
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};

export async function getServerSideProps(context) {
  const cookie = context.req.cookies?.language || "en"; // default fallback
  const initialData = await fetcher(
    `/api/terms-and-conditions?language=${cookie}`
  );

  return {
    props: {
      initialData,
      cookie,
    },
  };
}

TermsAndConditions.getLayout = (page) => (
  <Layout configUrl={PAGE_CONFIG_URL}>{page}</Layout>
);

export default TermsAndConditions;
